const MATOMO_URL = process.env.REACT_APP_MATOMO_URL
const MATOMO_SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID

let initialized = false

const normalizeMatomoUrl = (url) => {
  if (!url) return null

  return url.endsWith('/') ? url : `${url}/`
}

const isMatomoConfigured = () => {
  return Boolean(normalizeMatomoUrl(MATOMO_URL) && MATOMO_SITE_ID)
}

export const initMatomo = () => {
  if (initialized || !isMatomoConfigured()) return

  const matomoUrl = normalizeMatomoUrl(MATOMO_URL)

  window._paq = window._paq || []
  window._paq.push(['enableLinkTracking'])
  window._paq.push(['setTrackerUrl', `${matomoUrl}matomo.php`])
  window._paq.push(['setSiteId', MATOMO_SITE_ID])

  const firstScript = document.getElementsByTagName('script')[0]
  const matomoScript = document.createElement('script')

  matomoScript.async = true
  matomoScript.src = `${matomoUrl}matomo.js`

  firstScript.parentNode.insertBefore(matomoScript, firstScript)

  initialized = true
}

export const trackPageView = (url, title = document.title) => {
  if (!isMatomoConfigured()) return

  window._paq = window._paq || []
  window._paq.push(['setCustomUrl', url])
  window._paq.push(['setDocumentTitle', title])
  window._paq.push(['trackPageView'])
}

export const trackEvent = ({ category, action, name, value }) => {
  if (!isMatomoConfigured() || !category || !action) return

  window._paq = window._paq || []

  const event = ['trackEvent', category, action]

  if (name) event.push(name)
  if (typeof value === 'number') event.push(value)

  window._paq.push(event)
}

export const setMatomoUserId = (userId) => {
  if (!isMatomoConfigured()) return

  window._paq = window._paq || []

  if (userId) {
    window._paq.push(['setUserId', String(userId)])
    return
  }

  window._paq.push(['resetUserId'])
}